import { Link } from "react-router-dom";
import { CheckCircle, Lightning, Star, Phone } from "@phosphor-icons/react";

const Features = () => {
  const features = [
    {
      icon: <CheckCircle weight="bold" className="w-7 h-7" />,
      title: "Smart Artwork Analysis",
      description: "Instant quality checking with AI vectorization and enhancement.",
      color: "bg-acid",
    },
    {
      icon: <Lightning weight="bold" className="w-7 h-7" />,
      title: "Fast Turnaround",
      description: "Rush + emergency tiers. Production starts within 24 hours.",
      color: "bg-signal text-bone",
    },
    {
      icon: <Star weight="bold" className="w-7 h-7" />,
      title: "Volume Discounts",
      description: "Automatic pricing tiers — the more you order, the less you pay.",
      color: "bg-cobalt text-bone",
    },
    {
      icon: <Phone weight="bold" className="w-7 h-7" />,
      title: "Concierge Service",
      description: "Need help? Get a personalized quote from our team.",
      color: "bg-ink text-acid",
      link: "/concierge-quote",
    },
  ];

  return (
    <section className="border-b-2 border-ink py-14" data-testid="features-section">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6">
        <div className="mb-8">
          <span className="font-mono text-[11px] uppercase tracking-[0.12em] text-muted">Why Us</span>
          <h2 className="font-archivo text-3xl sm:text-4xl uppercase tracking-tight text-ink mt-1">Built Different</h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-0">
          {features.map((f, i) => {
            const Inner = (
              <div className={`border-2 border-ink p-6 ${i > 0 ? "lg:border-l-0" : ""} ${i > 1 ? "sm:border-t-0 lg:border-t-2" : ""} ${i === 1 ? "sm:border-l-0" : ""} ${i === 2 ? "border-t-0 sm:border-t-0 lg:border-t-2 lg:border-l-0" : ""} ${i === 3 ? "border-t-0 sm:border-l-0" : ""} bg-bone hover:bg-acid hover:text-ink transition-colors group`} data-testid={`feature-${i}`}>
                <div className={`w-12 h-12 ${f.color} border-2 border-ink flex items-center justify-center mb-4`}>
                  {f.icon}
                </div>
                <h3 className="font-inter text-base font-bold text-ink mb-1">{f.title}</h3>
                <p className="font-inter text-sm text-muted group-hover:text-ink-soft">{f.description}</p>
              </div>
            );
            return f.link ? (
              <Link key={f.title} to={f.link}>{Inner}</Link>
            ) : (
              <div key={f.title}>{Inner}</div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export { Features };
export default Features;
